import 'bootstrap'
import * as $ from 'jquery'

import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js'

/* Expose datepicker options */
window.DATEPICKER_OPTIONS = {
  format: 'dd/mm/yyyy',
  autoclose: true,
  startDate: "today",
  clearBtn: false,
  language: window.LANGUAGE_CODE,
  disableTouchKeyboard: true,
  orientation: 'auto',
  templates: {
    leftArrow: '<i class="fa fa-angle-left"></i>',
    rightArrow: '<i class="fa fa-angle-right"></i>'
  }
}
window.TIMEPICKER_OPTIONS = {
    minuteStep: 30,
    snapToStep: true,
    template: false,
    showSeconds: false,
    showMeridian: false,
    defaultTime: false
}

/*
 * Import StyleGuide
 */
import 'lib/content/asideNav.js'
import 'lib/components/_popup.js'


/*
 * Import Apps Static Files
 */
import '@root/js/payzen-auto-post.js'
import '@pro/apps.js'
import '@client/apps.js'
import '@activity/js/apps.js'
import '@box/js/apps.js'
import '@staff/js/apps.js'
import '@search/js/app.js'
import '@landing/js/apps.js'

import {AuthenticationFormsLoader} from './components/authentication-modal'
import {HelpModal} from './components/help-modal'

import LazyLoader from '@utils/js/lazy-loader'

import Cookies from 'js-cookie'

/*
 * Init Tools
 */

/* Expose authentication forms loader */
window.authenticationFormsLoader = new AuthenticationFormsLoader()

/* Auto scroll to input if invalid */ 
var elements = document.querySelectorAll('input,select,textarea');
for (var i = elements.length; i--;) {
    elements[i].addEventListener('invalid', function () {
        this.scrollIntoView({block: "center", inline: "nearest"});
    });
}

$(document).ready(function() {
  new LazyLoader(this)
})


// Modal help
function show_help_modal() {
  new HelpModal($('#help-modal'), $('#help-modal-conf'))
}
if(Cookies.get('help-pop') === undefined && $('#help-modal').length) {
  setTimeout(show_help_modal, 60000); 
}
$('#help-modal').on('hidden.bs.modal', function () {
    Cookies.set('help-pop', '1', { expires: 60 })
});


// Not sure of what I'm doing here but this fixes "jQuery is undefined" in
// init_tinymce.js
window.django = {jQuery: $}


// WEBPACK FOOTER //
// ./skippair/static/js/main.js